export const MINUTE = 60 * 1000;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const TEN_DAYS = 10 * DAY;
export const DAYS_IN_WEEK = 7;


